var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "device-rating-reviews" },
    [
      _c("div", { staticClass: "h4 mb-1 pb-0" }, [
        _vm._v("\n        " + _vm._s(_vm.title) + "\n    "),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "ob1-rating", style: _vm.ob1RatingStyle }, [
        _c("span", {
          staticClass: "ob1-stars",
          attrs: { "data-rating": _vm.roundedAverage, "aria-hidden": "true" },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "ob1-score ps-1" }, [
          _c("span", { staticClass: "visually-hidden" }, [_vm._v("Note ")]),
          _c("span", { staticClass: "h1" }, [
            _vm._v(_vm._s(_vm.formattedAverage)),
          ]),
          _c("span", { staticClass: "ob1-score-max ps-0" }, [_vm._v("/5")]),
          _c("span", { staticClass: "ob1-rating-label ps-1" }, [
            _vm._v(_vm._s(_vm.text)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("ob1-liens-icone", {
        attrs: {
          title: _vm.linkLabel,
          href: _vm.linkUrl,
          icon: "icon-info-alt",
          mini: true,
          target: "_blank",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }